import React from 'react';
import { Link } from 'react-router-dom';
import site from '../../data/site';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`${styles.inner} mc-shell`}>
        <div>
          <p className="mc-eyebrow">Get in touch</p>
          <a className={styles.email} href={site.socials.find((s) => s.id === 'email').href}>
            lucas.reljic@gmail.com
          </a>
        </div>

        <nav className={styles.links} aria-label="Footer">
          <Link to="/" className={styles.link}>Home</Link>
          {site.socials
            .filter((s) => s.id !== 'email')
            .map((s) => (
              <a key={s.id} className={styles.link} href={s.href} target="_blank" rel="noreferrer">
                {s.label}
              </a>
            ))}
        </nav>

        <p className={styles.colophon}>
          © {new Date().getFullYear()} {site.name} · Built with React
        </p>
      </div>
    </footer>
  );
}
